<template>

  <div>

    <div class="wrapper__inner--narrow">
      
      <section :class="pageCss">
        <span v-if="content.image" class="image__wrapper"><img :src="content.image"></span>
      </section>

    </div>

  </div>

</template>

<script>

  export default {
    name: 'SectionSeperator',
    props: {
      content: {
        type: Object,
        required: true,
        default: () => {}
      }
    },
    computed: {

      pageCss() {
        return `content content__seperator`;
      },

    }
  };
</script>